/*eslint-disable*/ export const messages = {
    "Go to the first page": "Ir a la primera página",
    "Go to the last page": "Ir a la última página",
    "Pagination, showing {from} through {to} of {total} entities": [
        "Paginación, mostrando ",
        ["from"],
        " a ",
        ["to"],
        " de ",
        ["total"],
        " entidades",
    ],
    "Show next {entitiesPerPage} entities": ["Mostrar las siguientes ", ["entitiesPerPage"], " entidades"],
    "Show previous {entitiesPerPage} entities": ["Mostrar las ", ["entitiesPerPage"], " entidades anteriores"],
    "{from} through {to} of {total}": [["from"], " a ", ["to"], " de ", ["total"]],
    "{from}-{to} of {total}": [["from"], "-", ["to"], " de ", ["total"]],
};
